import { tooltips } from '@/tooltips/tutorial_editor'

const state = {
	showTooltips: false,
	tooltips
}

const getters = {
	tipsShown: state => state.showTooltips && !state.tutorial.id,
	currentTip: state => state.tooltips[state.tooltips.currentTip]
}

const mutations = {
	showTooltips: (state) => {
		state.showTooltips = true
	},

	nextTip: (state) => {
		const currentTipKey = state.tooltips.order[state.tooltips.currentTip]
		const nextTipKey = state.tooltips.order[state.tooltips.currentTip + 1] || false

		if (nextTipKey) {
			state.tooltips[currentTipKey].active = false
			state.tooltips[nextTipKey].active = true
		}

		state.tooltips.currentTip = state.tooltips.currentTip + 1
	}
}

const actions = {
	checkTooltips: ({commit}) => {
		const localStorageKey = 'gcTutorialEditorTooltipsShown'
		if (typeof localStorage === 'undefined') return
		const tipsAlreadyShown = localStorage.getItem(localStorageKey)
		if (tipsAlreadyShown !== 'true') {
			commit('showTooltips')
			localStorage.setItem(localStorageKey, 'true')
		}
	}
}

export default {
	state,
	getters,
	mutations,
	actions
}
